import Login from "../auth/Login";

const OptionsLogin = () => {
  return <Login isFromOptions />;
};

export default OptionsLogin;
